import { Styles } from '@t2c/shared-fe';

export const loginStyle: Styles = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    p: 2,
    pb: 4,
  },
  gridContainer: {
    rowGap: 4,
  },
  gridItem: {
    display: 'flex !important',
    alignItems: 'center',
    position: 'relative',
  },
  loginCover: {
    maxHeight: 400,
    maxWidth: 400,
    borderRadius: 8,
  },
  title: {
    fontWeight: 600,
    fontSize: 24,
  },
  googleIcon: {
    backgroundColor: '#fff',
    borderRadius: '100%',
    fontSize: '24px !important',
    padding: '2px',
  },
  loginBtn: {
    mt: 2,
    // background: (theme) => theme.palette.gradients.gradient1,
    color: (theme) => theme.palette.common.white,
    height: '56px',
    borderRadius: '6px',
    minWidth: { xs: 'auto', lg: 375 },
    fontWeight: 500,
    fontSize: '16px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: (theme) => theme.shadows[4],
    },
  },
  loginContainer: {
    // height: '100%',
    p: { xs: 2, lg: 8 },
    borderRadius: 3,
    position: 'relative',
    height: { xs: '95%', sm: '80%', lg: 'auto' },
    display: { xs: 'flex', lg: 'block' },
    alignItems: 'flex-end',
    justifyContent: { xs: 'center', sm: 'center' },
  },
};
